import React from "react";

// Slim announcement bar shown site-wide above the navbar.
// Pure CSS marquee for a lightweight, editorial feel.
const MESSAGES = [
    "COMING SOON",
    "LAUNCHING WINTER 2026",
    "FOLLOW US ON INSTAGRAM @TONY.RAYS",
    "SIMPLICITY IS FREEDOM",
];

const Track = () => (
    <div className="inline-flex items-center whitespace-nowrap">
        {MESSAGES.map((m, i) => (
            <span key={i} className="inline-flex items-center">
                <span className="text-[11px] tracking-[0.28em] uppercase text-paper/90 px-8">
                    {m}
                </span>
                <span className="inline-block h-[3px] w-[3px] rounded-full bg-paper/40" />
            </span>
        ))}
    </div>
);

export const AnnouncementBar = () => (
    <div
        data-testid="announcement-bar"
        className="fixed top-0 inset-x-0 z-[60] bg-ink text-paper py-2.5 border-b border-paper/10 overflow-hidden"
    >
        <div className="announce-track flex whitespace-nowrap">
            <Track />
            <Track />
        </div>
    </div>
);

export default AnnouncementBar;
